module.exports = __webpack_public_path__ + "img/add-button.77627695.svg";